import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Each user gets their own document: portfolios/{uid}
const getPortfolioDoc = (uid) => doc(db, 'portfolios', uid);

/**
 * Load portfolio data for the given user.
 * Returns the document data, or null if it doesn't exist yet.
 */
export const loadFromFirestore = async (uid) => {
  try {
    const snap = await getDoc(getPortfolioDoc(uid));
    return snap.exists() ? snap.data() : null;
  } catch (error) {
    console.error('Error loading from Firestore:', error);
    return null;
  }
};

/**
 * Strip all undefined values (deeply) before writing to Firestore.
 * JSON round-trip is the simplest and most reliable way: undefined keys are
 * removed and undefined array elements become null, both safe for Firestore.
 */
const sanitize = (data) => JSON.parse(JSON.stringify(data));

/**
 * Persist portfolio data for the given user (merge so partial updates are safe).
 */
export const saveToFirestore = async (uid, data) => {
  try {
    await setDoc(getPortfolioDoc(uid), sanitize(data), { merge: true });
  } catch (error) {
    console.error('Error saving to Firestore:', error);
    throw error;
  }
};

/**
 * Subscribe to real-time changes on a user's portfolio document.
 * Returns an unsubscribe function.
 */
export const subscribeToPortfolio = (uid, callback) => {
  return onSnapshot(getPortfolioDoc(uid), (snap) => {
    if (snap.exists()) {
      callback(snap.data());
    }
  }, (error) => {
    console.error('Firestore subscription error:', error);
  });
};
